(function() {
    'use strict';

    angular
        .module('app')
        .directive('adminOptions', adminOptions);

    adminOptions.$inject = ['$window'];
    
    function adminOptions($window) {
        // Usage:
        //     <adminOptions></adminOptions>
        // Creates:
        // 
        var directive = {
            restrict: 'EA',
            templateUrl: 'app/options/templates/adminoptions.html',
            controllerAs: 'vm',
            controller: 'adminoptions',
        };
        return directive;
    }

})();